import { ITablePagination } from 'chakra-paginated-table'
import { z } from 'zod'
import { USER_SCHEMA } from './schema'

/**Supported Keys for the validator */
export const UserSchema = {
  firstName: 'firstName',
  lastName: 'lastName',
  email: 'email',
  phone: 'phone',
  language: 'language',
  leadStatus: 'leadStatus',
  country: 'country',
  description: 'description',
  agentId: 'agentId',
  account: 'account',
  tag: 'tag',
} as const

// add other schema
export type ISchema = z.infer<typeof USER_SCHEMA> & { lineNo: string }

interface ILineRow {
  index: number
  data: ISchema
}

export interface IErrorSate {
  currentRow: ILineRow | null
  invalidFields: Record<string, string | number>
}

export type TErrorState = IErrorSate[] | string

export const requiredCols: (keyof typeof UserSchema)[] = [
  'firstName',
  'lastName',
  'email',
  'phone',
  'language',
  'leadStatus',
  'country',
]

export interface IInitState {
  columns: string[]
  dataSource: ISchema[]
  errorState: TErrorState | undefined
  schemaFixes: ISchema[]
}

export const TABLE_PAGE_SIZE = 100

export const commonPaginationProps: Partial<ITablePagination> = {
  containerProps: {
    bgColor: 'gray.100',
    mb: '0.5rem',
    maxWidth: '100%',
    overflow: 'auto',
  },
  btnProps: {
    bg: 'gray.400',
    borderRight: '1px solid white',
  },
  __selectedBtnProps: {
    bgColor: 'gray.600',
    color: 'white',
  },
  position: 'topLeft',
}
